import { useContext, useEffect, useState } from 'react'
import { StatisticsContext } from '../../../context/StatisticsContext'
import StatisticsService from '../../../services/StatisticsService'
import { statisticsColors } from '../StatisticsPage'
import CustomPaper from '../../../containers/Paper'
import { Bar } from 'react-chartjs-2'
import { CircularProgress } from '@mui/material'

interface AreaCountType {
    count: number
    sector: string
}

interface DataType {
    responsibilityLevel: string
    mostCommonSector: AreaCountType[]
}

const DEFAULT_DATA: AreaCountType[] = [
    {
        count: 0,
        sector: '',
    },
    {
        count: 0,
        sector: '',
    },
    {
        count: 0,
        sector: '',
    },
    {
        count: 0,
        sector: '',
    },
    {
        count: 0,
        sector: '',
    },
]

const CommonAreasByHierarchy = () => {
    const { startDate, endDate, carreer } = useContext(StatisticsContext)
    const [data, setData] = useState<DataType[]>()

    useEffect(() => {
        new StatisticsService()
            .getCommonAreasByHierarchy(carreer, startDate, endDate, '5')
            .then((response) => {
                if (response.status !== 200) return
                const result = response.data as DataType[]
                setData(
                    result.length > 0
                        ? [
                              result.find((x) => x.responsibilityLevel === 'Liderazgo')!,
                              result.find((x) => x.responsibilityLevel === 'Gerencial')!,
                              result.find((x) => x.responsibilityLevel === 'Directivo')!,
                          ]
                        : [],
                )
            })
    }, [carreer, startDate, endDate])

    const getChartData = (index: number) => {
        const sectorData =
            data!.at(index) === undefined ? DEFAULT_DATA : data!.at(index)!.mostCommonSector

        for (let i = 0; i < 5; i++) {
            if (sectorData.length < 5 || sectorData[index] === undefined)
                sectorData.push({ sector: '', count: 0 })
        }

        return {
            labels: sectorData.map((x) => x.sector),
            datasets: [
                {
                    label: 'Graduados en el nivel jerárquico',
                    data: sectorData.map((x) => x.count),
                    backgroundColor: statisticsColors.background,
                    borderColor: statisticsColors.border,
                    borderWidth: 1,
                },
            ],
        }
    }

    const getOptions = (index: number) => ({
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                },
                // max: Math.max(
                //     ...(data!
                //         .map((x) => x.mostCommonSector)
                //         .flat()
                //         .map((y) => y.count) as number[]),
                // ),
            },
            x: {
                ticks: {
                    callback: function (tickIndex: any) {
                        const label =
                            data!.at(index) === undefined
                                ? ''
                                : data!.at(index)!.mostCommonSector.at(tickIndex)!.sector ?? ''
                        return label.length > 15 ? label.slice(0, 12) + '...' : label
                    },
                },
            },
            customGroups: {
                axis: 'x' as 'x',
                labels: [data!.at(index) === undefined ? '' : data!.at(index)!.responsibilityLevel],
                reverse: true,
                grid: {
                    drawOnChartArea: false,
                    lineWidth: 2,
                },
            },
        },
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label(context: any) {
                        const label: string = context.dataset.label
                        const value = context.raw
                        return `${label}: ${value}`
                    },
                },
            },
        },
    })

    return (
        <CustomPaper className={`flex flex-col gap-2 h-full md:h-[400px] text-primary`}>
            <div className="flex w-full items-start gap-2 md:gap-0 justify-between">
                <span className="text-lg font-semibold">
                    Áreas con mayor cantidad de graduados en puestos jerárquicos, diferenciado por
                    nivel
                </span>
            </div>
            <div className="flex-1 flex justify-center items-center">
                {data ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10 w-full h-full">
                        <div>
                            <Bar
                                data={getChartData(0)}
                                options={getOptions(0)}
                            />
                        </div>
                        <div>
                            <Bar
                                data={getChartData(1)}
                                options={getOptions(1)}
                            />
                        </div>
                        <div>
                            <Bar
                                data={getChartData(2)}
                                options={getOptions(2)}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="w-full h-full flex justify-center items-center">
                        <CircularProgress
                            className="m-2 md:m-5 text-primary"
                            size={64}
                        />
                    </div>
                )}
            </div>
        </CustomPaper>
    )
}

export default CommonAreasByHierarchy
